import React from 'react';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12'
  };

  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src="/taxyukti_logo.png" 
        alt="TaxYukti Logo" 
        className={`${sizeClasses[size]} mr-3 object-contain`}
      />
      <span className="text-xl font-bold text-gray-900">TaxYukti</span>
    </div>
  );
};

export default Logo; 